import { useEffect, useRef } from "react";

/**
 * A custom React hook that remembers the previous provided value if the new value is null.
 *
 * @param {any} value - The value to remember across component re-renders.
 * @returns {any} The remembered value. If `value` is provided, it returns `value`.
 */
function useRemember(value) {
	const remembered = useRef(value ?? {});

	useEffect(() => {
		if (value != null) remembered.current = value;
	}, [value]);

	return value ?? remembered.current;
}

export default useRemember;
